const deliveryTypes = {
    DELIVERY: 'DELIVERY',
    RETURN: 'RETURN'
};

export {deliveryTypes};
